import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import {
    widgetDataUpdate,
    widgetDataCleanUp,
} from '~SpectateStore/actions/widgetDataActions';
import { eventDataCleanUp } from '~SpectateStore/actions/eventDataCleanUp';

export const widgetsAdapter = createEntityAdapter();

const widgetsSlice = createSlice({
    name: 'widgets',
    initialState: widgetsAdapter.getInitialState(),
    reducers: {
        addWidget: widgetsAdapter.addOne,
        removeWidget: widgetsAdapter.removeOne,
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                widgetDataUpdate,
                (state, { payload : { widgetData = {} } }) => {
                    if (Object.keys(widgetData).length > 0) {
                        return widgetsAdapter.setOne(state, widgetData);
                    }

                    return state;
                },
            )
            .addCase(
                widgetDataCleanUp,
                (state, { payload: { widget_id } }) => {
                    return widgetsAdapter.removeOne(state, widget_id);
                },
            )
            .addCase(
                eventDataCleanUp,
                (state, { payload : { eventId } }) => {
                    const updatedEntities = [];
                    Object.values(state.entities).forEach(({ id, widgetEventPointers = [], event_order = []}) => {

                        if (!widgetEventPointers.some(({ event_id }) => event_id === eventId)) {
                            return;
                        }

                        const updatedPointers = widgetEventPointers.filter(pointer => pointer.event_id !== eventId);
                        const updatedEventOrder = event_order.filter(pointer => pointer.event_id !== eventId);

                        const updateData = {
                            id,
                            changes: {
                                widgetEventPointers: updatedPointers,
                                event_order: updatedEventOrder,
                            },
                        };

                        updatedEntities.push(updateData);
                    });

                    return widgetsAdapter.updateMany(state, updatedEntities);
                },
            );
    },
});

export const { addWidget, removeWidget } = widgetsSlice.actions;
export default widgetsSlice.reducer;
